import React from 'react';
import './Marquee.scss';

const Marquee: React.FC = () => {
  return (
    <div className="marquee-container">
      <div className="marquee">
      <a href="/">WELCOME TO SJM POLYTECHNIC ! </a>
      <p>
  Admissions are now open for the 2025-2026 academic year. |{' '}
  <a href="https://dtek.karnataka.gov.in/english" target="_blank" rel="noopener noreferrer">
    2025-26 Syllabus :- https://dtek.karnataka.gov.in/english
  </a>{' '}
  | Contact us for more details.
</p>

      </div>
    </div>
  );
};

export default Marquee;
